import { appHttpRequest } from "@/utils/AppHttpRequest";
import { ciHttpRequest } from "@/utils/CiHttpRequest";
import { IPage } from "@/types/FmsTypes";
import {
    ISCMWarehouseSearch, ISCMShelvesBatchInsert, ISCMWarehouseDetail, ISCMWarehouseInsert, ISCMWarehouseUpdate, ISCMAreaSearchFields, ISCMAreaDetail, ISCMAreaInsert, ISCMAreaBatchInsert, ISCMAreaUpdate, ISCMShelvesSearch, ISCMShelvesDetail, ISCMShelvesInsert, ISCMShelvesUpdate, ISCMshelfSearch, ISCMshelfDetail, ISCMshelfInsert, ISCMshelfBatchInsert, ISCMShelfUpdate, ISCMWhOrAreaShelvesSearch
} from "./warehouseTypes";

class WarehouseService {
    //仓库
    async scmPage(searchVo: ISCMWarehouseSearch) {
        const apiUrl = "/scm2/base/warehouse/listPage";
        return await appHttpRequest.post<IPage<ISCMWarehouseDetail>>(apiUrl, searchVo);
    }
    async vrmPage(searchVo: ISCMWarehouseSearch) {
        const apiUrl = "/vrm2/base/warehouse/findPage";
        return await appHttpRequest.post<IPage<ISCMWarehouseDetail>>(apiUrl, searchVo);
    }
    async bcmPage(searchVo: ISCMWarehouseSearch) {
        const apiUrl = "/bcm/base/warehouse/findPage";
        return await appHttpRequest.post<IPage<ISCMWarehouseDetail>>(apiUrl, searchVo);
    }
    async ciPage(searchVo: ISCMWarehouseSearch) {
        const apiUrl = "/ci-storage/base/warehouse/findPage";
        return await ciHttpRequest.post<IPage<ISCMWarehouseDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/scm2/base/warehouse/findById/${id}`;
        return await appHttpRequest.get<ISCMWarehouseDetail>(apiUrl);
    }
    async insert(insertVo: ISCMWarehouseInsert) {
        const apiUrl = "/scm2/base/warehouse/insert";
        return await appHttpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: ISCMWarehouseUpdate) {
        const apiUrl = "/scm2/base/warehouse/update";
        return await appHttpRequest.post<boolean>(apiUrl, updateVo);
    }


    async areaPage(searchVo: ISCMAreaSearchFields) {
        const apiUrl = "/scm2/base/warehouse/area/listPage";
        return await appHttpRequest.post<IPage<ISCMAreaDetail>>(apiUrl, searchVo);
    }
    async areaInsert(insertVo: ISCMAreaInsert) {
        const apiUrl = "/scm2/base/warehouse/area/insert";
        return await appHttpRequest.post<boolean>(apiUrl, insertVo);
    }
    //批量录入区域
    async areaBatchInsert(insertVo: ISCMAreaBatchInsert) {
        const apiUrl = "/scm2/base/warehouse/area/batchinsert";
        return await appHttpRequest.post<boolean>(apiUrl, insertVo);
    }
    async areaUpdate(updateVo: ISCMAreaUpdate) {
        const apiUrl = "/scm2/base/warehouse/area/update";
        return await appHttpRequest.post<boolean>(apiUrl, updateVo);
    }

    async shelvesPage(searchVo: ISCMShelvesSearch) {
        const apiUrl = "/scm2/base/warehouse/shelves/listPage";
        return await appHttpRequest.post<IPage<ISCMShelvesDetail>>(apiUrl, searchVo);
    }
    async shelvesInsert(insertVo: ISCMShelvesInsert) {
        const apiUrl = "/scm2/base/warehouse/shelves/insert";
        return await appHttpRequest.post<boolean>(apiUrl, insertVo);
    }
    //批量录入货架
    async shelvesBatchInsert(insertVo: ISCMShelvesBatchInsert) {
        const apiUrl = "/scm2/base/warehouse/shelves/batchinsert";
        return await appHttpRequest.post<boolean>(apiUrl, insertVo);
    }
    async shelvesUpdate(updateVo: ISCMShelvesUpdate) {
        const apiUrl = "/scm2/base/warehouse/shelves/update";
        return await appHttpRequest.post<boolean>(apiUrl, updateVo);
    }
    //根据仓库，多个id  查询货架
    async whOrAreaShelvesPage(searchVo: ISCMWhOrAreaShelvesSearch) {
        const apiUrl = "/scm2/base/warehouse/shelves/listBy";
        return await appHttpRequest.post<IPage<ISCMShelvesDetail>>(apiUrl, searchVo);
    }

    async shelfPage(searchVo: ISCMshelfSearch) {
        const apiUrl = "/scm2/base/warehouse/shelf/listPage";
        return await appHttpRequest.post<IPage<ISCMshelfDetail>>(apiUrl, searchVo);
    }
    async shelfPageAll(searchVo: ISCMshelfSearch) {
        const apiUrl = "/scm2/base/warehouse/shelf/listPageAll";
        return await appHttpRequest.post<ISCMshelfDetail[]>(apiUrl, searchVo);
    }
    async shelfInsert(insertVo: ISCMshelfInsert) {
        const apiUrl = "/scm2/base/warehouse/shelf/insert";
        return await appHttpRequest.post<boolean>(apiUrl, insertVo);
    }
    //批量新增货位
    async shelfBatchInsert(insertVo: ISCMshelfBatchInsert) {
        const apiUrl = "/scm2/base/warehouse/shelf/batchInsert";
        return await appHttpRequest.post<boolean>(apiUrl, insertVo);
    }
    async shelfUpdate(updateVo: ISCMShelfUpdate) {
        const apiUrl = "/scm2/base/warehouse/shelf/update";
        return await appHttpRequest.post<boolean>(apiUrl, updateVo);
    }

}

export const warehouseService = new WarehouseService();
